'use client';

import { useSyncExternalStore } from 'react';

import { type AbstractLocale } from '@/components/search/abstract-preview-content';

const ABSTRACT_LOCALE_STORAGE_KEY = 'suppr.abstract-preview-locale';
const ABSTRACT_LOCALE_STORAGE_EVENT = 'suppr:abstract-preview-locale-change';

function isAbstractLocale(value: string | null): value is AbstractLocale {
  return value === 'zh' || value === 'en';
}

export function useAbstractLocalePreference() {
  const locale = useSyncExternalStore(
    (onStoreChange) => {
      window.addEventListener('storage', onStoreChange);
      window.addEventListener(
        ABSTRACT_LOCALE_STORAGE_EVENT,
        onStoreChange,
      );
      return () => {
        window.removeEventListener('storage', onStoreChange);
        window.removeEventListener(
          ABSTRACT_LOCALE_STORAGE_EVENT,
          onStoreChange,
        );
      };
    },
    (): AbstractLocale => {
      const storedLocale = window.localStorage.getItem(
        ABSTRACT_LOCALE_STORAGE_KEY,
      );
      return isAbstractLocale(storedLocale) ? storedLocale : 'zh';
    },
    (): AbstractLocale => 'zh',
  );

  const updateLocale = (nextLocale: AbstractLocale) => {
    window.localStorage.setItem(ABSTRACT_LOCALE_STORAGE_KEY, nextLocale);
    window.dispatchEvent(new Event(ABSTRACT_LOCALE_STORAGE_EVENT));
  };

  return [locale, updateLocale] as const;
}
